export class RejectPendingInviteAction {
  static readonly type = '[PendingInvites] RejectPendingInviteAction';
  constructor(public userId: string, public groupId: string) {}
}
export class AcceptPendingInviteAction {
  static readonly type = '[PendingInvites] Accepte';
  constructor(public userId: string, public groupId: string) {}
}
